(function () {
  function initCountdown(el) {
    if (el.bmOfferTimer) {
      clearInterval(el.bmOfferTimer);
      el.bmOfferTimer = null;
    }
    var mode = el.getAttribute('data-mode') || 'daily';
    var endRaw = (el.getAttribute('data-end') || '').trim();
    var hEl = el.querySelector('[data-bm-hours]');
    var mEl = el.querySelector('[data-bm-min]');
    var sEl = el.querySelector('[data-bm-sec]');

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function getTarget() {
      if (mode === 'fixed' && endRaw) {
        var d = new Date(endRaw.replace(' ', 'T'));
        if (!isNaN(d.getTime())) return d.getTime();
        return 0;
      }
      var midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      return midnight.getTime();
    }

    function tick() {
      var diff = getTarget() - Date.now();
      if (diff < 0) diff = 0;
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    el.bmOfferTimer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-bm-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      initCountdown(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  if (!window.__fmOfferCountdownBound) {
    window.__fmOfferCountdownBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var nodes = e.target && e.target.querySelectorAll ? e.target.querySelectorAll('[data-bm-countdown]') : [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].bmOfferTimer) {
          clearInterval(nodes[i].bmOfferTimer);
          nodes[i].bmOfferTimer = null;
        }
      }
    });
  }
})();
